"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.workUpload = exports.workUpdate = exports.workList = exports.workDelete = exports.typeUpload = exports.typeListAll = exports.typeList = exports.typeDelete = exports.newsUpload = exports.newsUpdate = exports.newsList = exports.newsDelete = exports.nameUpload = exports.nameListAll = exports.nameList = exports.nameDelete = exports.getContestNotice = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
var _qs = _interopRequireDefault(require("qs"));
// 比赛公告 根据id获取详情
var getContestNotice = exports.getContestNotice = function getContestNotice(data) {
  return _api.default.request({
    url: '/contestNotice/getContestNotice',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};

// 比赛类型 查询全部
var typeListAll = exports.typeListAll = function typeListAll(data) {
  return _api.default.request({
    url: '/contestType/getListAll',
    method: 'post',
    data: data
  });
};

// 比赛类型 分页查询
var typeList = exports.typeList = function typeList(data) {
  return _api.default.request({
    url: '/contestType/getList',
    method: 'post',
    data: data
  });
};

// 比赛类型 新增/编辑
var typeUpload = exports.typeUpload = function typeUpload(data) {
  return _api.default.request({
    url: '/contestType/insertOrUpdateContestType',
    method: 'post',
    data: data
  });
};

// 比赛类型 删除
var typeDelete = exports.typeDelete = function typeDelete(data) {
  return _api.default.request({
    url: '/contestType/deleteContestType',
    method: 'post',
    data: data
  });
};

// 比赛名称 查询全部
var nameListAll = exports.nameListAll = function nameListAll(data) {
  return _api.default.request({
    url: '/contest/getListAll',
    method: 'post',
    data: data
  });
};

// 比赛名称 分页查询
var nameList = exports.nameList = function nameList(data) {
  return _api.default.request({
    url: '/contest/getList',
    method: 'post',
    data: data
  });
};

// 比赛名称 新增/编辑
var nameUpload = exports.nameUpload = function nameUpload(data) {
  return _api.default.request({
    url: '/contest/insertOrUpdateContest',
    method: 'post',
    data: data
  });
};

// 比赛名称 删除
var nameDelete = exports.nameDelete = function nameDelete(data) {
  return _api.default.request({
    url: '/contest/deleteContest',
    method: 'post',
    data: data
  });
};

// 赛事公告 分页查询
var newsList = exports.newsList = function newsList(data) {
  return _api.default.request({
    url: '/contestNotice/getList',
    method: 'post',
    data: data
  });
};

// 赛事公告 新增/编辑
var newsUpload = exports.newsUpload = function newsUpload(data) {
  return _api.default.request({
    url: '/contestNotice/insertOrUpdateContestNotice',
    method: 'post',
    data: data
  });
};

// 赛事公告 删除
var newsDelete = exports.newsDelete = function newsDelete(data) {
  return _api.default.request({
    url: '/contestNotice/deleteContestNotice',
    method: 'post',
    data: data
  });
};

// 赛事公告 发布
var newsUpdate = exports.newsUpdate = function newsUpdate(data) {
  return _api.default.request({
    url: '/contestNotice/updateStatus',
    method: 'post',
    data: data
  });
};

// 作品管理 分页查询
var workList = exports.workList = function workList(data) {
  return _api.default.request({
    url: '/contestWork/getList',
    method: 'post',
    data: data
  });
};

// 作品管理 新增/编辑
var workUpload = exports.workUpload = function workUpload(data) {
  return _api.default.request({
    url: '/contestWork/insertOrUpdateContestWorks',
    method: 'post',
    data: data
  });
};

// 作品管理 删除
var workDelete = exports.workDelete = function workDelete(data) {
  return _api.default.request({
    url: '/contestWork/deleteContestWorks',
    method: 'post',
    data: data
  });
};

// 作品管理 发布
var workUpdate = exports.workUpdate = function workUpdate(data) {
  return _api.default.request({
    url: '/contestWork/updateStatus',
    method: 'post',
    data: data
  });
};